import React from "react";
import { Button, DialogTitle, Divider, Grid, IconButton, Drawer, Typography } from "@mui/material";
import { Cancel, GetApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";

const iOS = typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);

const drawer = {
    width: 420,
    maxWidth: "100%",
};

const stickyFilterButtons = {
    textAlign: "center",
    position: "sticky",
    bottom: "0",
    zIndex: "1",
};

function FilterDrawer(props) {
    const { t } = useTranslation();

    return (
        <Drawer style={drawer} anchor={"right"} open={props.open} variant="temporary" onClose={props.onClose} onOpen={props.onOpen} disableBackdropTransition={!iOS} disableDiscovery={iOS}>
            <Box style={{ marginLeft: 20 }}>
                <Grid container alignItems="center" sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Grid item>
                        <Typography id="detailFilterTitle" color="primary" variant="h6">
                            {t("Filter")}
                        </Typography>
                    </Grid>
                    {props.downloadExcel ? (
                        <Grid item>
                            <IconButton id="fd_IconButton_Excel" onClick={props.downloadExcel} disabled={!props.downloadExcel} disableRipple={!props.downloadExcel}>
                                <GetApp id="fd_GetAppIcon" fontSize="large" style={{ color: "#008000" }} />
                            </IconButton>
                        </Grid>
                    ) : (
                        <Box m={5} />
                    )}
                    <Grid item>
                        <DialogTitle disableTypography className="drawerTitle">
                            <IconButton id="fd_IconButton_Cancel" onClick={props.onClose}>
                                <Cancel align="end" />
                            </IconButton>
                        </DialogTitle>
                    </Grid>
                </Grid>
            </Box>
            <Divider />
            {props.detailFilter}
            <Grid container style={stickyFilterButtons}>
            
                <Grid item xs={6} sm={6}>
                    <Button id="fd_Button_Clean" onClick={props.HandleClearFilter} variant="contained" color="secondary" >
                        {t("Clean")}
                    </Button>
                </Grid>
                <Grid item xs={6} sm={6}>
                    <Button id="fd_Button_Apply" onClick={props.HandleApplyFilter} variant="contained" disabled={props.isEquipmentSelected}>
                        {t("Apply")}
                    </Button>
                </Grid>
            </Grid>
        
            
        </Drawer>
    );
}

export default FilterDrawer;
